import React from "react";

import { DefaultLayout } from "shared/components";

import Typography from "@material-ui/core/Typography";

export function NotFoundPage() {
  return (
    <DefaultLayout>
      <Typography variant="h4">요청하신 페이지를 찾을 수 없습니다.</Typography>
    </DefaultLayout>
  );
}
